import { appConst } from "../AppConst";
import { IBaoCaoCategory } from "../model/respone/report/IReportRespone";

export const eTinhChatHoc = {
  hoc_di: 0,
  hoc_lai: 1,
  hoc_cai_thien: 2,
  hoc_vuot: 3,
  hoc_ngoai_chuong_trinh: 4,
};

export const eMode = {
  sua: 0,
  xem: 1,
};

export const eTrangThaiTaiChinh = {
  tao_moi: 0,
  yeu_cau_huy: 1,
  duyet: 2,
};

export const eNamNhapHocStart = 2020;

export const eListBaoCao: IBaoCaoCategory[] = [
  {
    id: 1,
    name: "Tổng hợp khoản thu theo hệ",
    type: "theo-ky",
  },
  {
    id: 2,
    name: "Tổng hợp khoản thu theo lớp",
    type: "theo-ky",
  },
  {
    id: 3,
    name: "Tổng hợp khoản thu theo sinh viên",
    type: "theo-ky",
  },
  {
    id: 4,
    name: "Dự toán khoản thu theo hệ",
    type: "theo-ky",
  },
  {
    id: 5,
    name: "Dự toán khoản thu theo lớp",
    type: "theo-ky",
  },
  {
    id: 6,
    name: "Dự toán khoản thu theo sinh viên",
    type: "theo-ky",
  },
  {
    id: 7,
    name: "Tổng hợp rút học phần theo sinh viên",
    type: "theo-ky",
    is_tin_chi: true,
  },
  {
    id: 8,
    name: "Tổng hợp rút học phần theo lớp",
    type: "theo-ky",
    is_tin_chi: true,
  },
];

export const eTypeHDDieuChinh: any = [
  {
    id: 2,
    text: "Điều chỉnh tăng",
  },
  {
    id: 3,
    text: "Điều chỉnh giảm",
  },
  {
    id: 4,
    text: "Hóa đơn điều chỉnh thông tin",
  },
];

export const eHinhThucDaoTao: any = [
  {
    code: "chuyen-nganh-chinh",
    text: "Chuyên ngành chính",
  },
  {
    code: "song-nganh",
    text: "Song ngành",
  },
];

export const eMauSoPrint = {
  bien_lai_sinh_vien: appConst.MAU_BIEN_LAI_SINH_VIEN,
  bien_lai_sinh_vien_nhap_hoc: appConst.MAU_BIEN_LAI_SINH_VIEN_NHAP_HOC,
  bien_lai_thi_sinh_tuyen_sinh: appConst.MAU_BIEN_LAI_THI_SINH_TUYEN_SINH,
  bien_lai_theo_lop: "02",
};

export const eLoaiBienLai = {
  theo_ky: 0,
  nhap_hoc: 1,
  tuyen_sinh: 2,
};

export const eTypeBieuDo = {
  cong_no_toan_truong: 0,
  cong_no_theo_he: 1,
  cong_no_theo_khoa: 2,
  cong_no_theo_khoa_hoc: 3,
};
